import { request } from './request.js';

// 校验输入的哈希值
export const checkFingerprintByCode = (params) => {
  const config = {
    noCode: true,
  }
  return request(`/notarial-deed/check-fingerprint-by-code`, params, config)
}

// 校验上传文件的哈希值
export const checkFingerprintByFile = (params) => {
  const config = {
    noCode: true,
  }
  return request(`/notarial-deed/check-fingerprint-by-file`, params, config)
}

